import { useContext, useEffect, useState, useCallback} from "react"
import { AuthContext } from "../../context/auth";
import { APIGET } from "../../utils/api";
import ONGDash from "../../interfaces/dash";
import MktDashTable from "./mktDashCard"; // Renamed import to match component name

export default function UserAdmin() 
{
    localStorage.removeItem('id');

    const userContext = useContext(AuthContext);
    const [dashONGList, setdashONGList] = useState<ONGDash[]>([]);
    const [showResult, setResult] = useState<boolean>(false);

    const getQuestionariesONG = useCallback(() => {
        APIGET('POST', `${userContext?.api_url}/company/listDashboardComp`).then((resp) => {
            if (resp.status === "OK") {
                if(resp.info.length === 0) {
                    setResult(false);
                } else {
                    setdashONGList(resp.info);
                    setResult(true);
                }
            }
        });
    }, [userContext?.api_url]);

    useEffect(() => {
        getQuestionariesONG();
    }, [getQuestionariesONG]);

    return(
        <div className="justify-center items-center content-center flex overflow-x-hidden overflow-y-auto inset-0 z-50 outline-none focus:outline-none bg-principal-3">
            {showResult ? (
                // Pass the entire array at once rather than mapping each item
                <MktDashTable ongDashList={dashONGList} />
            ) : (
                <div className="flex w-full text-3xl font-semibold text-principal-2 items-center justify-center h-screen">
                    <h1>Aún no se ha llenado ningún cuestionario.</h1>
                </div>
            )}
        </div>
    );
}